<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  // metaInfo() {
  //   return {
  //     meta: this.metaData
  //   }
  // },
  // data() {
  //   return {
  //     metaData: [{
  //       name: 'viewport',
  //       content: 'width=device-width, user-scalable=no, initial-scale=0.3, maximum-scale=0.2, minimum-scale=0.2'
  //     }]
  //   }
  // },
//   watch: {
//     $route(to, from) {
//       if (to.name == 'Cha') {
//         this.metaData = [{
//           name: 'viewport',
//           content: 'width=device-width, user-scalable=no, initial-scale=0.3, maximum-scale=0.2, minimum-scale=0.2'
//         }]
//       } else {
//         this.metaData = [{
//           name: 'viewport',
//           content: 'width=device-width,initial-scale=1.0'
//         }]
//       }
//     },
// }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue